import React from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'

import { statusColor } from 'functions/status'

import Box from 'suitTheme/Box'
import Text from 'suitTheme/Text'

import styles from './styles.scss'

const getColorProps = (props) => {
  const { color, ghost, status } = props

  const boxColor = color || statusColor(status, null)

  if (ghost && boxColor){
    return { color: boxColor, background: 'none' }
  }

  if (boxColor){
    return { color: 'white', backgroundColor: boxColor, borderColor: boxColor }
  }
}

const StatusBadge = (props) => {
  const {
    boxProps, color, ghost, icon, light, status, text,
  } = props

  const colorProps = getColorProps(props)
  const textClass = text ? text.split(' ')[0].toLowerCase() : null

  return (
    <Box
      alignItems="center"
      borderStyle="solid"
      borderRadius="5px"
      borderWidth={light ? 1 : 2}
      display="inline-flex"
      justifyContent="center"
      paddingX="medium"
      paddingY="small"
      width="fit-content"
      className={classnames(color ? null : styles[textClass], ghost ? styles.ghost : null)}
      {...boxProps}
      {...colorProps}
    >
      <Text
        as="span"
        color={null}
        fontSize="xxsmall"
        fontWeight={light ? 'normal' : 'bold'}
        style={{ letterSpacing: '1px', textTransform: 'uppercase', whiteSpace: 'nowrap' }}
      >
        {icon || text || status}
      </Text>
    </Box>
  )
}

StatusBadge.propTypes = {
  boxProps: PropTypes.object,
  color: PropTypes.string,
  ghost: PropTypes.bool,
  icon: PropTypes.object,
  light: PropTypes.bool,
  status: PropTypes.string,
  text: PropTypes.string,
}

StatusBadge.defaultProps = {
  ghost: false,
}

export default StatusBadge
